import { atom } from "recoil";

const nameState =atom({
    key: 'name',
    default: ''
})

export default nameState